import React, { Component } from 'react';
import '../report-page.component.css';
import { HorizontalBarGraph } from '../../../common/graph/bar-graph.component';
import { ChartHeaderDropdown } from '../../../common/data-header/chart-header-dropdown.component';

const graphData = [
        { name: "United States of America", value:71957.54},
        { name: "United States of America", value:32174.37},
        { name: "Romania", value:34166.84},
        { name: "United States of America", value:0},
        { name: "United States of America", value:0}
  ];

class topCountries extends Component {

    
    render() {        
        return (
            <div className="component-container">              
                <ChartHeaderDropdown haveOneIcone={true} haveIconInfo={true} iconInfo="info-circle-solid" haveLedger={false} headerName="Top 5 Countries" circleIcon={false} circleFirstIcon="list-regular" circleSecondIcon="th-solid" oneIcon="vertical-grid" 
                   haveInput={false} haveDropdown={false}   />
                <HorizontalBarGraph data={graphData} fill="#a100ff" withMargin={true} />
            </div>
        )
    }

}

export default topCountries;